import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useMilitaryChartsDataContext } from './hooks/useMilitaryChartsDataContext';
import { useMemo } from 'react';

const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

const getMonthLabel = (mes) => {
    const monthIndex = parseInt(mes) - 1;
    const monthName = monthNames[monthIndex] || mes;
    return `${monthName}`;
};

export const BattalionEvolutionMonth = () => {
    const { chartData } = useMilitaryChartsDataContext();

    // Transform data to show each battalion (battalion) evolution by month
    const { series, categories } = useMemo(() => {
        let monthData = chartData?.battalionEvolutionMonth || [];
        
        if (!monthData.length) {
            return { series: [], categories: [] };
        }

        // Sort data chronologically by year and month
        monthData = [...monthData].sort((a, b) => {
            const yearDiff = parseInt(a.ano_estatistica) - parseInt(b.ano_estatistica);
            if (yearDiff !== 0) return yearDiff;
            return parseInt(a.mes_estatistica) - parseInt(b.mes_estatistica);
        });

        // Limit to 12 consecutive months (last 12)
        monthData = monthData.slice(-12);

        // Get all unique battalions
        const battalionsSet = new Set();
        monthData.forEach(period => {
            period.batalhoes?.forEach(battalion => {
                battalionsSet.add(battalion.battalion);
            });
        });

        // Create series for each battalion
        const battalionSeries = Array.from(battalionsSet).map(battalionName => {
            const data = monthData.map(period => {
                const battalionData = period.batalhoes?.find(b => b.battalion === battalionName);
                return battalionData?.total || 0;
            });
            return {
                name: battalionName,
                data: data
            };
        });

        // Get month/year as categories
        const monthCategories = monthData.map(item => 
            getMonthLabel(item.mes_estatistica)
        );

        return {
            series: battalionSeries,
            categories: monthCategories
        };
    }, [chartData?.battalionEvolutionMonth]);

    return (
        <SimpleBars
            title={'Ocorrências por Batalhão (Mensal)'}
            horizontal={false}
            stacked={true}
            subtitles={categories}
            series={series}
            isMoney={false}
            showDataLabels={false}
        />
    );
};